import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast, InlineSpinner } from '../components/UI';
import AuthShell from '../components/AuthShell';

export default function LoginPage() {
  const { login } = useAuth();
  const toast     = useToast();
  const navigate  = useNavigate();

  const [form,    setForm]    = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPw,  setShowPw]  = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!form.username || !form.password) {
      setError('Please enter your username and password.');
      return;
    }
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast('Welcome back!', 'success');
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
          <h1 className="lg-title">Welcome Back</h1>
          <p className="lg-sub">Sign in to your TMIS account</p>

          {error && (
            <div role="alert" aria-live="polite" className="lg-err">
              <i className="bi bi-exclamation-circle-fill" aria-hidden="true" style={{ flexShrink: 0, marginTop: 1 }} />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="lg-field">
              <label htmlFor="sms-username" className="lg-label">Username or Mobile Number (for Student)</label>
              <input
                id="sms-username"
                className="lg-input"
                type="text"
                autoComplete="username"
                placeholder="Enter your username"
                value={form.username}
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                disabled={loading}
              />
            </div>

            <div className="lg-field">
              <label htmlFor="sms-password" className="lg-label">Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  id="sms-password"
                  className="lg-input has-toggle"
                  type={showPw ? 'text' : 'password'}
                  autoComplete="current-password"
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                  disabled={loading}
                />
                <button
                  type="button"
                  className="lg-show"
                  onClick={() => setShowPw(s => !s)}
                  aria-label={showPw ? 'Hide password' : 'Show password'}
                  aria-pressed={showPw}
                >
                  {showPw ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            <div className="lg-actions">
              <button type="submit" className="lg-btn" disabled={loading}>
                {loading
                  ? <><InlineSpinner size={15} /> Signing In…</>
                  : <><i className="bi bi-lock-fill" aria-hidden="true" /> Sign In</>
                }
              </button>
              <Link to="/forgot-password" className="lg-link">Forgot Student Password?</Link>
            </div>
          </form>
    </AuthShell>
  );
}
